// src/services/VentaService.js
import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const SaleService = {
    fetchVentas: async ({ token, pagina = 1, pageSize = 20, desde, hasta, dni, nombre }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/ventas/todas'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, dni, nombre },
            });

            return {
                ventas: response.data.ventas || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en VentaService.fetchVentas:', error);
            throw error;
        }
    },
    fetchVentasAvances: async ({ token, pagina = 1, pageSize = 20, desde, hasta, dni, nombre,list }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/ventas-avances/'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, dni, nombre,list },
            });

            return {
                ventas: response.data.ventas || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en VentaService.fetchVentas:', error);
            throw error;
        }
    },
    fetchVentasReported: async ({ token, pagina = 1, pageSize = 20, desde, hasta, dni, nombre, list, reported = false }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/ventas-avances/reported'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, dni, nombre,list, reported },
            });

            return {
                ventas: response.data.ventas || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en VentaService.fetchVentas:', error);
            throw error;
        }
    },
    fetchVentasInstalado: async ({ token, pagina = 1, pageSize = 20, desde, hasta, dni, nombre, list }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/ventas/instaladas'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, dni, nombre, list },
            });

            return {
                ventas: response.data.ventas || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en VentaService.fetchVentas:', error);
            throw error;
        }
    },
    exportarVentasInstaladasExcel: async (token, filtros) => {
        try {
            const response = await axios.post(buildApiUrl('/api/ventas/exportarVentasInstaladas'), filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en ExportacionService.exportarVentasInstaladasExcel:', error);
            throw error;
        }
    },
    getStatisticsInstaladas: async ({ token, yearSelected, monthSelected }) => {
        try {
            const response = await axios.get(buildApiUrl(`/api/ventas/countinstalada?year=${yearSelected}&month=${monthSelected > 9 ? monthSelected : `0${monthSelected}`}`), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            console.error('Error en VentaService.getStatistics:', error);
            throw error;
        }
    },
    getStatistics: async ({ token, yearSelected, monthSelected }) => {
        try {
            const response = await axios.get(buildApiUrl(`/api/ventas-avances/count?year=${yearSelected}&month=${monthSelected > 9 ? monthSelected : `0${monthSelected}`}`), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            console.error('Error en VentaService.getStatistics:', error);
            throw error;
        }
    },
    validarCodigo: async (token, codigo) => {
        try {
            const response = await axios.get(buildApiUrl(`/api/ventas/validar-codigo/${codigo}`), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data.existe;
        } catch (error) {
            console.error('Error en CodigoClienteService.validarCodigo:', error);
            throw error;
        }
    },
    exportarVentasExcel: async (token, filtros) => {
        try {
            const response = await axios.post(buildApiUrl('/api/ventas/exportar'), filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en ExportacionService.exportarVentasExcel:', error);
            throw error;
        }
    },
    exportarVentasAvancesExcel: async (token, filtros) => {
        try {
            const response = await axios.post(buildApiUrl('/api/ventas-avances/exportar'), filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en ExportacionService.exportarVentasAvancesExcel:', error);
            throw error;
        }
    },
    exportarReporteVentasExcel: async (token, filtros) => {
        try {
            const response = await axios.post(buildApiUrl('/api/ventas/exportarReporte'), filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en ExportacionService.exportarReporteVentasExcel:', error);
            throw error;
        }
    },
    fetchVentaPorId: async (token, id) => {
        try {
            const response = await axios.get(buildApiUrl(`/api/ventas/${id}`), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response || {};
        } catch (error) {
            console.error('Error en VentaService.fetchVentaPorId:', error);
            throw error;
        }
    },
    fetchAvanceVentaPorId: async (token, id) => {
        try {
            const response = await axios.get(buildApiUrl(`/api/ventas-avances/${id}`), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response || {};
        } catch (error) {
            console.error('Error en VentaService.fetchVentaPorId:', error);
            throw error;
        }
    },
    fetchVentasReporte: async ({ token, pagina = 1, pageSize = 20, desde, hasta, nombre, vendedores, estado, regiones }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/ventas/reporte'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, nombre, vendedores, regiones, estado },
            });

            return {
                ventas: response.data.ventas || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en VentaService.fetchVentas:', error);
            throw error;
        }
    },
    getEstadoVenta: async (token) => {
        try {
            const response = await axios.get(
                buildApiUrl('/api/ajustes/estadoventa'),
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data.estadoVenta;
        } catch (error) {
            console.error('Error en VentaService.getEstadoVenta:', error);
            throw error;
        }
    },
};
